import React from "react";

type Props = {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
};

export const DecimalField: React.FC<Props> = ({
  value,
  onChange,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const inputValue = e.target.value;

    // Allow empty string
    if (inputValue === "") {
      onChange(null);
      return;
    }

    // Allow valid decimal numbers (including negative and partial inputs like "3.")
    if (/^-?\d*\.?\d*$/.test(inputValue)) {
      // Don't parse if it ends with a dot (partial input)
      if (inputValue.endsWith(".") || inputValue === "-") {
        return; // Keep the input as-is for now
      }
      onChange(parseFloat(inputValue));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    // Prevent 'e', 'E', '+' from being entered (but allow decimal point)
    if (["e", "E", "+"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      value={value !== null && value !== undefined ? String(value) : ""}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md
        focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent
        disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed"
    />
  );
};
